/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * PID Simulations request payload
 * @export
 * @interface PidSimulationRequest
 */
export interface PidSimulationRequest {
    /**
     * 
     * @type {number}
     * @memberof PidSimulationRequest
     */
    invoiceId?: number;
}

/**
 * Check if a given object implements the PidSimulationRequest interface.
 */
export function instanceOfPidSimulationRequest(value: object): value is PidSimulationRequest {
    return true;
}

export function PidSimulationRequestFromJSON(json: any): PidSimulationRequest {
    return PidSimulationRequestFromJSONTyped(json, false);
}

export function PidSimulationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PidSimulationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'invoiceId': json['invoiceId'] == null ? undefined : json['invoiceId'],
    };
}

export function PidSimulationRequestToJSON(json: any): PidSimulationRequest {
    return PidSimulationRequestToJSONTyped(json, false);
}

export function PidSimulationRequestToJSONTyped(value?: PidSimulationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoiceId': value['invoiceId'],
    };
}

